var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9995 10C16.9995 10.9193 16.8185 11.8295 16.4667 12.6788C16.1149 13.5281 15.5993 14.2997 14.9493 14.9497C14.2992 15.5998 13.5276 16.1154 12.6783 16.4672C11.829 16.8189 10.9188 17 9.99951 17C9.08026 17 8.17001 16.8189 7.32073 16.4672C6.47145 16.1154 5.69977 15.5998 5.04976 14.9497C4.39975 14.2997 3.88414 13.5281 3.53236 12.6788C3.18057 11.8295 2.99951 10.9193 2.99951 10C2.99951 8.14348 3.73701 6.36301 5.04976 5.05025C6.36252 3.7375 8.143 3 9.99951 3C11.856 3 13.6365 3.7375 14.9493 5.05025C16.262 6.36301 16.9995 8.14348 16.9995 10ZM13.3225 14.383C12.2636 15.1864 10.9496 15.5792 9.62346 15.4887C8.29735 15.3981 7.04888 14.8304 6.109 13.8905C5.16911 12.9506 4.6014 11.7022 4.51086 10.3761C4.42032 9.04994 4.81309 7.73591 5.61651 6.677L13.3225 14.383ZM14.3825 13.323L6.67651 5.617C7.73542 4.81358 9.04945 4.42081 10.3756 4.51135C11.7017 4.60189 12.9501 5.1696 13.89 6.10949C14.8299 7.04937 15.3976 8.29783 15.4882 9.62395C15.5787 10.9501 15.1859 12.2641 14.3825 13.323Z",
    fill: "#002CFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/iconCancel.a8ccaebacca828e2d42989c6db047b96.svg";
export { ForwardRef as ReactComponent };